import { changePasswordSchema } from '@proerp/shared';

/**
 * Prüft eine Passwort-Änderung, bevor sie an die API geht. Nutzt bewusst das
 * GETEILTE Schema (CLAUDE.md §9) — so gilt hier dieselbe Mindestlänge wie im
 * Backend, auch wenn sie dort später einmal steigt.
 *
 * Zusätzlich zwei Regeln, die das Schema nicht kennen kann: Die Wiederholung
 * muss passen, und das neue Passwort darf nicht das bisherige sein. Beim
 * erzwungenen Erstwechsel wäre Letzteres sonst ein Weg, ihn mit dem
 * durchgegebenen Anfangspasswort zu „erledigen".
 *
 * Liegt hier und nicht in einer Komponente, weil beide Stellen sie brauchen:
 * der erzwungene Wechsel beim Erstlogin und die Einstellungen-Seite.
 */
export function validateNewPassword(input: {
  currentPassword: string;
  newPassword: string;
  repeated: string;
}): string | null {
  const parsed = changePasswordSchema.safeParse({
    currentPassword: input.currentPassword,
    newPassword: input.newPassword,
  });
  if (!parsed.success) {
    return parsed.error.issues[0]?.message ?? 'Bitte prüfe deine Eingabe.';
  }
  if (input.newPassword !== input.repeated) {
    return 'Die beiden Passwörter stimmen nicht überein.';
  }
  if (input.newPassword === input.currentPassword) {
    return 'Bitte wähle ein anderes Passwort als das bisherige.';
  }
  return null;
}
